import { isFolderItem } from "./isFolderItem.js";
import { isNullItem } from "./isNullItem.js";
import { shortenFolderLabel } from "./shortenFolderLabel.js";
import { COLLAPSE_THRESHOLD_MULTIPLICATOR, FOLDER_SEPARATOR } from "../constants/folderNaming.js";
/**
 * Group results by folder and options
 * Find all results by filterFn
 * @param items
 * @param searchString
 * @param filterFn custom filter function
 * @param folderCollapseThreshold amount of chars where folder names will be collapsed to ...
 * @param folderLabel
 */
export function filterItems(items, searchString, filterFn, folderCollapseThreshold = 20, folderLabel = '') {
  const folderResults = [];
  const optionResults = [];
  items.forEach(item => {
    if (isNullItem(item)) {
      return;
    }
    const label = folderLabel ? `${folderLabel}${FOLDER_SEPARATOR}${item.label}` : item.label;
    if (isFolderItem(item)) {
      const matchPositions = filterFn(item, searchString);
      if (matchPositions) {
        const shortenedLabel = shortenFolderLabel(label, folderCollapseThreshold);
        const highlightOffset = label.length - item.label.length - shortenedLabel.removedCharsAmount;
        folderResults.push({
          ...item,
          highlightStart: matchPositions.highlightStart + highlightOffset,
          highlightEnd: matchPositions.highlightEnd + highlightOffset,
          label: shortenedLabel.label
        });
      }
      const {
        folderResults: innerFolderResults,
        optionResults: innerOptionResults
      } = filterItems(item.elements, searchString, filterFn, folderCollapseThreshold, label);
      folderResults.push(...innerFolderResults);
      optionResults.push(...innerOptionResults);
      return;
    }
    const matchPositions = filterFn(item, searchString);
    if (matchPositions) {
      const shortenedLabel = shortenFolderLabel(folderLabel, Math.floor(folderCollapseThreshold * COLLAPSE_THRESHOLD_MULTIPLICATOR));
      optionResults.push({
        ...item,
        highlightStart: matchPositions.highlightStart,
        highlightEnd: matchPositions.highlightEnd,
        folderLabel: shortenedLabel.label
      });
    }
  });
  return {
    folderResults,
    optionResults
  };
}